import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'store/types'

const appealFormSlice = (state: RootState) => state.stateCurrentAppeal
const stateNewAppeal = (state: RootState) => state.newAppeal

export const stateCurrentAppeal = createSelector(
  appealFormSlice,
  appealForm => appealForm,
)

export const newAppealState = createSelector(
  stateNewAppeal,
  newAppeal => newAppeal,
)
